var Controller = require("common/Controller");
var Utils = require("common/Utils");

function AuthenticationController(authenticationDialog) {
    Controller.call(this);

    var self = this;

    /**
     * @override
     * @inheritsDoc
     */
    this.getId = function() {
        return "AuthenticationController";
    };

    this.getViews = function() {
        return [authenticationDialog];
    };

    self.subscribeTo("post-authentication-credentials", function(data) {
        self.postAuthenticationCredentials(data.submitData, data.launchId, data.deferred, data.launchCallback);
    });

    this.resolveCredentials = function(launchId, launchCallback, title) {
        return authenticationDialog.promptForAttributes(launchId, launchCallback, title);
    };

    this.postAuthenticationCredentials = function(submitData, launchId, deferred, launchCallback) {
        return $.ajax({
            url : "/sslvpn_api/vfs/setcredentials",
            type : "POST",
            data : {
                credentials : JSON.stringify(submitData),
                vfsId : launchId
            }
        }).done(function() {
            launchCallback();
            authenticationDialog.postDone(deferred, submitData);
        }).fail(function(xHR) {
            console.info("error setting credentials");
            var errorsJson = xHR.responseJSON.validationErrors;
            authenticationDialog.postFailed(errorsJson);
        });
    };
}

Utils.inherits(AuthenticationController, Controller);

module.exports = AuthenticationController;